import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { ITINERARY_CHANGE_ROUTE_PATH } from '../../../../config/paths';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import {
  clearItineraryChangeRoute,
  getItineraryChangeRoute,
} from '../../../../actions/itinerary/ItineraryChangeRoute';
import ItineraryChangeRouteBasicInformationResource from './resource/ItineraryChangeRouteBasicInformationResource';

export const ItineraryChangeRoute = ({
  breadcrumbs,
  dispatchGetActivity,
  dispatchClearActivity,
  match: {
    params: { id: itineraryChangeRouteId },
  },
  loading,
  itineraryChangeRoute,
}) => {
  useLayoutEffect(() => {
    dispatchGetActivity({ itineraryChangeRouteId });

    return () => dispatchClearActivity();
  }, []);

  let content;

  if (loading) content = <Loader />;
  else if (itineraryChangeRoute.isEmpty())
    content = <NoDataResource returnPage={ITINERARY_CHANGE_ROUTE_PATH} />;
  else {
    const itineraryChangeRouteJson = itineraryChangeRoute.toJS();

    content = (
      <>
        <h3>Información Básica</h3>
        <ItineraryChangeRouteBasicInformationResource
          {...itineraryChangeRouteJson}
        />
      </>
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Cambio de Ruta en Itinerarios"
      content={content}
    />
  );
};

ItineraryChangeRoute.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearActivity: PropTypes.func.isRequired,
  dispatchGetActivity: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  itineraryChangeRoute: PropTypes.instanceOf(Immutable.Map).isRequired,
};

ItineraryChangeRoute.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearActivity: clearItineraryChangeRoute,
  dispatchGetActivity: getItineraryChangeRoute,
};

const mapStateToProps = ({ ItineraryUnit }) => ({
  breadcrumbs: [
    ...ItineraryUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Cambios de Ruta en Itinerarios',
      href: ITINERARY_CHANGE_ROUTE_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  itineraryChangeRoute: ItineraryUnit.ItineraryChangeRoute.getIn([
    'current',
    'content',
  ]),
  loading: !ItineraryUnit.ItineraryChangeRoute.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ItineraryChangeRoute);
